export default "__VITE_ASSET__E1kD1aoz__"